import { Field, Form, Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import {
  uomCreateAction,
  uomImportAction,
  uomListAction,
  uomUpdateAction,
} from "../../../../redux/actions/settings-action";
import successToast from "../../../helper-components/success-toast";
import errorToast from "../../../helper-components/error-toast";
import AddButton from "../../../buttons/button";
import search from "../../../../assets/icons/searchIcon.svg";
import LoadingSpinner from "../../../helper-components/loading-spinner";
import InnerLayout from "../../../layouts/inner-layout";
import { ChevronLeftIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import useCsvUpload from "../../../helper-components/upload-csv-custom-hook";
import LoadingButtonSpinner from "../../../helper-components/loading-button-spinner";
import {
  downloadAllTemplates,
  downloadAllTemplatesJson,
} from "../../../helper-components/helper-function";
import DownloadIcon from "../../../../assets/icons/download-icon";
import excelImg from "../../../../assets/icons/excel.png";
import { customStyles } from "../../../tables/filtering-section2";
import { FileJson } from "lucide-react";

const UnitOfMeasure = () => {
  const searchRef = useRef();
  const addRef = useRef();
  const tableHeading = [
    "UOM Code",
    "UOM Name",
    "EWB Unit",
    "Length",
    "Width",
    "Height",
    "Volume",
    "Volume UOM",
    "Weight",
  ];
  const searchFilter = [
    {
      label: "UOM code",
      value: "code",
    },
    {
      label: "UOM Name",
      value: "name",
    },
  ];
  const [reload, setReload] = useState(false);
  const [isFocused, setIsFocused] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [filterData, setFilterData] = useState({
    searchColumn: "name",
    searchValue: "",
  });
  const [disableArrayFields, setDisableArrayFields] = useState(false);
  const [disableNewFields, setDisableNewFields] = useState(false);
  const [initialData, setUomListData] = useState([]);
  const [mainLoading, setMainLoading] = useState(true);
  const handleFieldChange = (index, field, value, setFieldValue) => {
    setFieldValue(`${index}.${field}`, value);
  };
  useEffect(() => {
    dispatch(
      uomListAction(filterData, onFetchUomLIstSuccess, onFetchUomLIstError)
    );
  }, [filterData, reload]);
  const onFetchUomLIstSuccess = (data) => {
    setUomListData(data?.data?.uomList);
    setMainLoading(false);
  };
  const onFetchUomLIstError = (data) => {
    setUomListData([]);
    setMainLoading(false);
    errorToast(data?.message);
  };
  const initialValues = {
    data: initialData,
    newLine: {
      code: "",
      name: "",
      ewb_unit: "",
      length: "",
      width: "",
      height: "",
      volume: "",
      volume_uom: "",
      weight: "",
    },
  };

  const onSubmit = (values, { setSubmitting }) => {
    const changedObjects = [];
    let newLineObject = null;

    // Collect changed array data
    initialData.forEach((item, index) => {
      if (JSON.stringify(values.data[index]) !== JSON.stringify(item)) {
        changedObjects.push(values.data[index]);
      }
    });
    // Collect new line data if it is altered
    if (
      JSON.stringify(values.newLine) !== JSON.stringify(initialValues.newLine)
    ) {
      newLineObject = values.newLine;
    }
    if (newLineObject !== null) {
      dispatch(uomCreateAction(newLineObject, onCreateSuccess, onCreateError));
    }
    if (changedObjects.length > 0) {
      dispatch(
        uomUpdateAction(
          { updatingData: changedObjects },
          onUpdateSuccess,
          onUpdateError
        )
      );
    }
    setSubmitting(false);
  };
  const onCreateSuccess = (data) => {
    if (addRef && addRef?.current) {
      addRef?.current?.focus();
    }
    setReload(!reload);
    setDisableArrayFields(false);
    setDisableNewFields(false);
    successToast(data?.message);
  };
  const onCreateError = (data) => {
    setDisableArrayFields(false);
    setDisableNewFields(false);
    errorToast(data?.data?.message);
  };
  const onUpdateSuccess = (data) => {
    // reloadData();
    setReload(!reload);
    if (addRef && addRef?.current) {
      addRef?.current?.focus();
    }
    setDisableArrayFields(false);
    setDisableNewFields(false);
    successToast(data?.message);
  };
  const onUpdateError = (data) => {
    setDisableArrayFields(false);
    setDisableNewFields(false);
    errorToast(data?.data?.message);
  };
  const handleSelectChange = (event) => {
    setFilterData({ ...filterData, searchColumn: event?.value });
  };

  const TemplateArray = [
    {
      documentType: "UOM Setup",
      expectedHeaders: [
        "code",
        "name",
        "ewb_unit",
        "length",
        "width",
        "height",
        "volume",
        "volume_uom",
        "weight",
      ],
    },
  ];

  const onSuccess = (data) => {
    setReload(!reload);
    successToast(data?.data?.message);
  };
  const { handleFileUpload, loading } = useCsvUpload(
    uomImportAction,
    TemplateArray?.[0]?.expectedHeaders
  );

  return (
    <InnerLayout
      list={true}
      title="Settings"
      module="uom-setup"
      // permissionFn={permissionFn}
    >
      <div className="mx-6">
        <Formik
          enableReinitialize={true}
          initialValues={initialValues}
          onSubmit={onSubmit}
        >
          {({ values, setFieldValue, dirty, handleSubmit }) => (
            <Form className="pt-1">
              <div className="flex flex-col" style={{ height: "85vh" }}>
                <div className="flex justify-between py-4 items-center ">
                  <div className="  flex items-center gap-2 text-sml">
                    <button
                      className="flex items-center gap-2"
                      onClick={() => {
                        navigate("/settings");
                      }}
                    >
                      <ChevronLeftIcon className="h-5 w-5 inline-block" />
                      Data Setup Settings /
                    </button>
                    <span className="cursor-pointer">{" " + "UOM Setup"}</span>
                  </div>
                  <div className="flex items-center gap-3 pr-3">
                    <div
                      style={{ maxWidth: "30rem", height: "2.6rem" }}
                      className={`w-full  flex items-center rounded-md   ${
                        isFocused ? "border border-focus-color" : "input_border"
                      }`}
                    >
                      <Select
                        className="z-30  text-xs placeholder:text-xs"
                        // menuPortalTarget={document.body}
                        styles={customStyles}
                        value={
                          filterData?.searchColumn
                            ? searchFilter?.find(
                                (item) =>
                                  item?.value === filterData?.searchColumn
                              )
                            : null
                        }
                        onChange={(e) => {
                          handleSelectChange(e);
                          setIsFocused(true);
                          if (searchRef && searchRef?.current) {
                            searchRef?.current?.focus();
                          }
                        }}
                        options={searchFilter}
                        placeholder="Select Column"
                        isSearchable={false}
                      />{" "}
                      <div
                        className={`h-full w-0.5 ${
                          isFocused
                            ? "border-r border-r-focus-color"
                            : "border-r border-r-D0D5DD"
                        }`}
                      ></div>{" "}
                      <input
                        ref={searchRef}
                        autoFocus={true}
                        onBlur={() => setIsFocused(false)}
                        onFocus={() => setIsFocused(true)}
                        placeholder={`Search`}
                        className=" table_search_input w-full rounded-md text-xs placeholder:text-xs h-full placeholder:text-text-sm placeholder:text-787878 pl-3"
                        type="text"
                        value={filterData?.searchValue}
                        onChange={(e) => {
                          setFilterData({
                            ...filterData,
                            searchValue: e.target.value,
                          });
                        }}
                      />
                      <span className="px-2">
                        <img
                          style={{
                            height: "25px",
                            width: "25px",
                          }}
                          src={search}
                          alt="search icon"
                        />
                      </span>
                    </div>

                    <div>
                      <input
                        type="file"
                        accept=".csv,.json"
                        onChange={(e) => handleFileUpload(e, onSuccess)} // Pass onSuccess and onError functions
                        className="hidden"
                        id="csv-upload"
                      />
                      <label htmlFor="csv-upload">
                        <div className="border-027A48 border-2 rounded-md flex items-center gap-2 text-nowrap px-5 py-2 fw_700">
                          <img
                            width={20}
                            height={30}
                            src={excelImg}
                            alt="excel-icon"
                          />
                          <FileJson width="20px" height="20px" />
                          {loading ? (
                            <LoadingButtonSpinner className="  h-6 w-6 border-t-2 border-027A48" />
                          ) : (
                            <span>Import CSV / JSON</span>
                          )}
                        </div>
                      </label>
                    </div>
                    <span title="Download CSV Template">
                      <button
                        type="button"
                        onClick={() => {
                          downloadAllTemplates(TemplateArray);
                        }}
                        className="border-027A48 border-2 rounded-md px-2 py-2"
                      >
                        <DownloadIcon fill="var(--success-color)" />
                      </button>
                    </span>
                    <span title="Download JSON Template">
                      <button
                        type="button"
                        onClick={() => {
                          downloadAllTemplatesJson(TemplateArray);
                        }}
                        className="border-027A48 border-2 rounded-md px-2 py-2"
                      >
                        <DownloadIcon fill="var(--success-color)" />
                      </button>
                    </span>
                  </div>
                </div>
                {mainLoading ? (
                  <LoadingSpinner />
                ) : (
                  <div className="overflow-auto rounded-xl table-container border border-gray-200">
                    <table className=" w-full ">
                      <thead className="sticky top-0 bg-[var(--create-table-header-bg)] z-[10]">
                        <tr className="relative h-[50px]">
                          {tableHeading.map((heading, index) => (
                            <th
                              className={`text-start px-[8px] whitespace-nowrap text-[var(--create-table-header-fg)] text-[length:var(--create-table-header-fs)] font-[var(--create-table-header-fw)]`}
                              key={heading}
                            >
                              {heading?.toUpperCase()}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody className="">
                        {values.data.map((item, index) => (
                          <tr key={index}>
                            <td
                              className={`tab-cell text-sm fw_400 text-secondary`}
                            >
                              <Field
                                name={`data[${index}].code`}
                                placeholder="Code"
                                disabled={disableArrayFields}
                                onChange={(e) =>
                                  handleFieldChange(
                                    `data[${index}]`,
                                    "code",
                                    e.target.value,
                                    setFieldValue
                                  )
                                }
                                className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded px-1 py-2 w-28"
                              />
                            </td>
                            <td
                              className={`tab-cell text-sm fw_400 text-secondary`}
                            >
                              <Field
                                name={`data[${index}].name`}
                                placeholder="Name"
                                disabled={disableArrayFields}
                                onChange={(e) =>
                                  handleFieldChange(
                                    `data[${index}]`,
                                    "name",
                                    e.target.value,
                                    setFieldValue
                                  )
                                }
                                className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded py-2 w-32"
                              />
                            </td>
                            <td
                              className={`tab-cell text-sm fw_400 text-secondary`}
                            >
                              <Field
                                name={`data[${index}].ewb_unit`}
                                type="number"
                                placeholder="Unit"
                                disabled={disableArrayFields}
                                onChange={(e) =>
                                  handleFieldChange(
                                    `data[${index}]`,
                                    "ewb_unit",
                                    e.target.value,
                                    setFieldValue
                                  )
                                }
                                className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded py-2 w-20"
                              />
                            </td>
                            <td
                              className={`tab-cell text-sm fw_400 text-secondary`}
                            >
                              <Field
                                name={`data[${index}].length`}
                                type="number"
                                placeholder="Length"
                                disabled={disableArrayFields}
                                onChange={(e) =>
                                  handleFieldChange(
                                    `data[${index}]`,
                                    "length",
                                    e.target.value,
                                    setFieldValue
                                  )
                                }
                                className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded py-2 w-20"
                              />
                            </td>
                            <td
                              className={`tab-cell text-sm fw_400 text-secondary`}
                            >
                              <Field
                                name={`data[${index}].width`}
                                type="number"
                                placeholder="Width"
                                disabled={disableArrayFields}
                                onChange={(e) =>
                                  handleFieldChange(
                                    `data[${index}]`,
                                    "width",
                                    e.target.value,
                                    setFieldValue
                                  )
                                }
                                className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded py-2 w-20"
                              />
                            </td>
                            <td
                              className={`tab-cell text-sm fw_400 text-secondary`}
                            >
                              <Field
                                name={`data[${index}].height`}
                                type="number"
                                placeholder="Height"
                                disabled={disableArrayFields}
                                onChange={(e) =>
                                  handleFieldChange(
                                    `data[${index}]`,
                                    "height",
                                    e.target.value,
                                    setFieldValue
                                  )
                                }
                                className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded py-2 w-20"
                              />
                            </td>
                            <td
                              className={`tab-cell text-sm fw_400 text-secondary`}
                            >
                              <Field
                                name={`data[${index}].volume`}
                                type="number"
                                placeholder="Volume"
                                disabled={disableArrayFields}
                                onChange={(e) =>
                                  handleFieldChange(
                                    `data[${index}]`,
                                    "volume",
                                    e.target.value,
                                    setFieldValue
                                  )
                                }
                                className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded py-2 w-20"
                              />
                            </td>
                            <td
                              className={`tab-cell text-sm fw_400 text-secondary`}
                            >
                              <Field
                                name={`data[${index}].volume_uom`}
                                type="text"
                                placeholder="volume uom"
                                disabled={disableArrayFields}
                                onChange={(e) =>
                                  handleFieldChange(
                                    `data[${index}]`,
                                    "volume_uom",
                                    e.target.value,
                                    setFieldValue
                                  )
                                }
                                className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded py-2 w-28"
                              />
                            </td>
                            <td
                              className={`tab-cell text-sm fw_400 text-secondary`}
                            >
                              <Field
                                name={`data[${index}].weight`}
                                type="number"
                                placeholder="Weight"
                                disabled={disableArrayFields}
                                onChange={(e) =>
                                  handleFieldChange(
                                    `data[${index}]`,
                                    "weight",
                                    e.target.value,
                                    setFieldValue
                                  )
                                }
                                className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded py-2 w-20"
                              />
                            </td>

                            {/* <td
                              className={`tab-cell text-center text-sm fw_400 bg-white text-secondary sticky right-0`}
                            >
                              <button
                                onClick={() => {
                                  deleteFn();
                                }}
                              >
                                {" "}
                                <DeleteIcon />
                              </button>
                            </td> */}
                          </tr>
                        ))}

                        <tr>
                          <td
                            className={`tab-cell text-sm fw_400 text-secondary`}
                          >
                            <Field
                              ref={addRef}
                              name="newLine.code"
                              placeholder="Code"
                              disabled={disableNewFields}
                              onChange={(e) =>
                                handleFieldChange(
                                  "newLine",
                                  "code",
                                  e.target.value,
                                  setFieldValue
                                )
                              }
                              className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded py-2 w-28"
                              // autoFocus={addRef?.current?.focus()}
                              autoFocus={false}
                            />
                          </td>
                          <td
                            className={`tab-cell text-sm fw_400 text-secondary`}
                          >
                            <Field
                              name="newLine.name"
                              placeholder="Name"
                              disabled={disableNewFields}
                              onChange={(e) =>
                                handleFieldChange(
                                  "newLine",
                                  "name",
                                  e.target.value,
                                  setFieldValue
                                )
                              }
                              className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded py-2 w-32"
                            />
                          </td>
                          <td
                            className={`tab-cell text-sm fw_400 text-secondary`}
                          >
                            <Field
                              name="newLine.ewb_unit"
                              type="number"
                              placeholder="Unit"
                              disabled={disableNewFields}
                              onChange={(e) =>
                                handleFieldChange(
                                  "newLine",
                                  "ewb_unit",
                                  e.target.value,
                                  setFieldValue
                                )
                              }
                              className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded py-2 w-20"
                            />
                          </td>
                          <td
                            className={`tab-cell text-sm fw_400 text-secondary`}
                          >
                            <Field
                              name="newLine.length"
                              type="number"
                              placeholder="Length"
                              disabled={disableNewFields}
                              onChange={(e) =>
                                handleFieldChange(
                                  "newLine",
                                  "length",
                                  e.target.value,
                                  setFieldValue
                                )
                              }
                              className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded py-2 w-20"
                            />
                          </td>
                          <td
                            className={`tab-cell text-sm fw_400 text-secondary`}
                          >
                            <Field
                              name="newLine.width"
                              type="number"
                              placeholder="Width"
                              disabled={disableNewFields}
                              onChange={(e) =>
                                handleFieldChange(
                                  "newLine",
                                  "width",
                                  e.target.value,
                                  setFieldValue
                                )
                              }
                              className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded py-2 w-20"
                            />
                          </td>
                          <td
                            className={`tab-cell text-sm fw_400 text-secondary`}
                          >
                            <Field
                              name="newLine.height"
                              type="number"
                              placeholder="Height"
                              disabled={disableNewFields}
                              onChange={(e) =>
                                handleFieldChange(
                                  "newLine",
                                  "height",
                                  e.target.value,
                                  setFieldValue
                                )
                              }
                              className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded py-2 w-20"
                            />
                          </td>
                          <td
                            className={`tab-cell text-sm fw_400 text-secondary`}
                          >
                            <Field
                              name="newLine.volume"
                              type="number"
                              placeholder="Volume"
                              disabled={disableNewFields}
                              onChange={(e) =>
                                handleFieldChange(
                                  "newLine",
                                  "volume",
                                  e.target.value,
                                  setFieldValue
                                )
                              }
                              className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded py-2 w-20"
                            />
                          </td>
                          <td
                            className={`tab-cell text-sm fw_400 text-secondary`}
                          >
                            <Field
                              name="newLine.volume_uom"
                              type="text"
                              placeholder="Volume UOM"
                              disabled={disableNewFields}
                              onChange={(e) =>
                                handleFieldChange(
                                  "newLine",
                                  "volume_uom",
                                  e.target.value,
                                  setFieldValue
                                )
                              }
                              className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded py-2 w-28"
                            />
                          </td>
                          <td
                            className={`tab-cell text-sm fw_400 text-secondary`}
                          >
                            <Field
                              name="newLine.weight"
                              type="number"
                              placeholder="Weight"
                              disabled={disableNewFields}
                              onChange={(e) =>
                                handleFieldChange(
                                  "newLine",
                                  "weight",
                                  e.target.value,
                                  setFieldValue
                                )
                              }
                              className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded py-2 w-20"
                            />
                          </td>
                          {/* <td
                            className={`tab-cell text-sm fw_400 bg-white text-secondary sticky right-0`}
                          ></td> */}
                        </tr>
                      </tbody>
                    </table>
                  </div>
                )}
              </div>

              <div className="flex justify-end w-full bg-white py-4">
                <AddButton
                  onclkFn={handleSubmit}
                  prefixIcon={false}
                  text="Save"
                  type="submit"
                  className="
                  flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
                  bg-[var(--primary-button-bg-color)] cursor-pointer
                  text-[var(--primary-button-fg-color)]
                  border border-[var(--primary-button-bg-color)]
                  hover:bg-[var(--primary-button-hover-color)]
                  text-[length:var(--primary-button-create-fs)] 
                  font-[var(--primary-button-font-weight)]
                  "
                />
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </InnerLayout>
  );
};

export default UnitOfMeasure;
